<template>
    <div class="preview-container">
        <embed v-if="fileUrl" :src="fileUrl" class="preview-embed" />
    </div>
</template>

<script>
    import AuthService from 'services/AuthService'

    export default {
        data() {
            return {
                fileUrl: null,
            }
        },

        methods: {
            getFile() {
                const url = this.$route.query.url
                fetch(url, {
                    responseType: 'blob',
                    headers: new Headers({
                        Authorization: `Bearer ${AuthService.getToken()}`,
                    }),
                })
                    .then((response) => response.blob())
                    .then((blob) => {
                        this.fileUrl = window.URL.createObjectURL(blob)
                    })
            },
        },

        mounted() {
            this.getFile()
        },
    }
</script>

<style>
    .preview-container {
        width: 100vw;
        height: 100vh;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }

    .preview-embed {
        width: 100%;
        height: 100%;
        border: none;
    }
</style>
